export const Arr_MentalHealthInfo = [
  //-------------------------------------------------------------------------
  //Mental Health

  // Start anxiety
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student experience anxiety",
    name: "MentalHealthInfo_anxiety",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "MentalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "MentalHealthInfo_anxiety_signs",
    selectValues: [
      {
        name: "MentalHealthInfo_anxiety_signs_quiet",
        label: "Quiet, less verbally communicative",
      },
      {
        name: "MentalHealthInfo_anxiety_signs_withdrawn",
        label: "Become withdrawn",
      },
      {
        name: "MentalHealthInfo_anxiety_signs_tearful",
        label: "Tearful or easily upset",
      },
      {
        name: "MentalHealthInfo_anxiety_signs_agitated",
        label: "Agitated or jumpy",
      },
      {
        name: "MentalHealthInfo_anxiety_signs_flushed",
        label: "Flushed face or sweating",
      },
      {
        name: "MentalHealthInfo_anxiety_signs_unable_concentrate",
        label: "Unable to concentrate",
      },
      {
        name: "MentalHealthInfo_anxiety_signs_talking_rapidly",
        label: "Talking rapidly or repetitively",
      },
      {
        name: "MentalHealthInfo_anxiety_signs_fidgeting",
        label:
          "Fidgeting (e.g. moving hands or fingers a lot, playing with an object such as a pen/ hair etc.)",
      },
      {
        name: "MentalHealthInfo_anxiety_signs_chewing_fingernails",
        label: "Chewing fingernails/ nailbeds",
      },
      {
        name: "MentalHealthInfo_anxiety_signs_using_phone",
        label: "Using their phone excessively",
      },
      {
        name: "MentalHealthInfo_anxiety_signs_becoming_tired",
        label: "Becoming tired, sleep affected",
      },
      {
        name: "MentalHealthInfo_anxiety_signs_appetite_affected_eating_less",
        label: "Appetite affected (not eating/ eating very little)",
      },
      {
        name: "MentalHealthInfo_anxiety_signs_appetite_affected_eating_more",
        label: "Appetite affected (eating more than usual/ eating a lot)",
      },
      {
        name: "MentalHealthInfo_anxiety_signs_self_harm",
        label: "Self-harm",
      },
      {
        name: "MentalHealthInfo_anxiety_signs_risk_taking",
        label: "Risk-taking behaviours",
      },

      {
        name: "MentalHealthInfo_anxiety_signs_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If the student is feeling anxious during their programme, it is useful
        for us to know what this looks like for each student so that we can care
        for their well-being. Please review the indicators below and select the
        applicable signs
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the self harm",
    name: "MentalHealthInfo_anxiety_signs_self_harm_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_signs_self_harm",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the risk taking",
    name: "MentalHealthInfo_anxiety_signs_risk_taking_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_signs_risk_taking",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details for any other behaviors",
    name: "MentalHealthInfo_anxiety_signs_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_signs_other",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "How much does their anxiety impact their day-to-day",
    name: "MentalHealthInfo_anxiety_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "MentalHealthInfo_anxiety_plan",
    selectValues: [
      {
        name: "MentalHealthInfo_anxiety_plan_welfare_checks",
        label:
          "Regular welfare checks with the student (this would be subtle and not in front of peers)",
      },
      {
        name: "MentalHealthInfo_anxiety_plan_day_timings",
        label:
          "Provide the student with in-depth information about each element of the programme day-by-day with timings (note these might be approximate and could be subject to change)",
      },
      {
        name: "MentalHealthInfo_anxiety_plan_breaks",
        label:
          "Give the student the opportunity for a short break outside of the room/ environment",
      },
      {
        name: "MentalHealthInfo_anxiety_plan_opt_out_presentations",
        label:
          "Opt out of giving presentations alone (and co-deliver with another student where possible)",
      },
      {
        name: "MentalHealthInfo_anxiety_plan_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If the student is feeling anxious, what are some of the ways that we can
        support them in the moment? We will always offer compassionate and
        pastoral support, the following options are some practical steps that
        might assist during programmes, please review the suggestions below and
        select those which could support the student
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the other support",
    name: "MentalHealthInfo_anxiety_plan_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_plan_other",
  },

  {
    Page: "MentalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "MentalHealthInfo_anxiety_support",
    selectValues: [
      {
        name: "MentalHealthInfo_anxiety_support_talking_family_friends",
        label: "Talking with family/ friends",
      },
      {
        name: "MentalHealthInfo_anxiety_support_mental_health_professional",
        label:
          "Support from a mental health professional (e.g. if the student has a therapist they can access during the programme) – please add more information to the ‘other’ box with details",
      },
      {
        name: "MentalHealthInfo_anxiety_support_grounding_techniques",
        label:
          "Grounding techniques such as ‘five things’ (please provide details in the ‘other, please specify’ box below",
      },
      {
        name: "MentalHealthInfo_anxiety_support_breathing_exercises",
        label: "Breathing exercises",
      },
      {
        name: "MentalHealthInfo_anxiety_support_meditation",
        label: "Meditation",
      },
      {
        name: "MentalHealthInfo_anxiety_support_going_for_a_walk",
        label: "Going for a walk",
      },
      {
        name: "MentalHealthInfo_anxiety_support_listening_to_music",
        label: "Listening to music/ podcast",
      },
      {
        name: "MentalHealthInfo_anxiety_support_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        Does the student have any specific support mechanisms that help them if
        they are feeling anxious? Please review the suggestions below and select
        all that apply
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the other support",
    name: "MentalHealthInfo_anxiety_support_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_support_other",
  },

  // anxiety Medication start

  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication",
    name: "MentalHealthInfo_anxiety_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety",
    AboveText: (
      <p>Does the student take any medication related to their condition</p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "MentalHealthInfo_anxiety_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_prescribed_medication",
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "MentalHealthInfo_anxiety_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "MentalHealthInfo_anxiety_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "MentalHealthInfo_anxiety_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "MentalHealthInfo_anxiety_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "MentalHealthInfo_anxiety_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "MentalHealthInfo_anxiety_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago)
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "MentalHealthInfo_anxiety_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please click the{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "MentalHealthInfo_anxiety_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_anxiety_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_anxiety_prescribed_medication_interact_badly",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "MentalHealthInfo_anxiety_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_anxiety_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_anxiety_prescribed_medication_anything_else",
  },

  // anxiety Medication end

  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Urgent or emergency care",
    name: "MentalHealthInfo_anxiety_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety",
    AboveText: (
      <p>
        Has the student had a serious incident related to their mental health
        and required urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "MentalHealthInfo_anxiety_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "When was the most recent incident",
    name: "MentalHealthInfo_anxiety_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Was the student admitted overnight to the hospital",
    name: "MentalHealthInfo_anxiety_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "NumberFieldForObjectState",
    label: "How many days was the student in hospital",
    name: "MentalHealthInfo_anxiety_serious_incident_attend_hospital_days",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_serious_incident_attend_hospital",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "How often",
    name: "MentalHealthInfo_anxiety_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their
        mental health
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "MentalHealthInfo_anxiety_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s mental health
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_anxiety_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety_anything_else",
  },
  // End anxiety

  // Start low_mood_depression
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Does the student experience low mood or depression",
    name: "MentalHealthInfo_low_mood_depression",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
  },
  {
    Page: "MentalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "MentalHealthInfo_low_mood_depression_signs",
    selectValues: [
      {
        name: "MentalHealthInfo_low_mood_depression_signs_quiet",
        label: "Quiet, less verbally communicative",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_signs_withdrawn",
        label: "Withdrawal from social situation",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_signs_teary",
        label: "Tearful or easily upset",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_signs_hygine",
        label: "Personal hygiene affected",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_signs_chewing_fingernails",
        label: "Chewing fingernails or nailbeds",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_signs_unable_concentrate",
        label: "Unable to concentrate",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_signs_stomach_pains_headaches",
        label: "Regular stomach pains or headaches",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_signs_apeptite_affected_eating_less",
        label: "Appetite affected (not eating/ eating very little)",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_signs_appetite_affected_eating_more",
        label: "Appetite affected (eating more than usual/ eating a lot)",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_signs_sleeping_less",
        label: "Visibly tired due to poor sleep",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_signs_sleeping_more",
        label: "Sleeping more than usual",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_signs_self_harm",
        label: "Self-harm",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_signs_risk_taking",
        label: "Risk-taking behaviours",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_signs_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If the student is feeling low or depressed during their programme, it is
        useful for us to know what this looks like for each student so that we
        can care for their well-being. Please review the indicators below and
        select the applicable signs
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the self harm",
    name: "MentalHealthInfo_low_mood_depression_signs_self_harm_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_signs_self_harm",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the risk taking",
    name: "MentalHealthInfo_low_mood_depression_signs_risk_taking_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_signs_risk_taking",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details for any other behaviors",
    name: "MentalHealthInfo_low_mood_depression_signs_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_signs_other",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "How much does this impact their day-to-day",
    name: "MentalHealthInfo_low_mood_depression_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "MentalHealthInfo_low_mood_depression_plan",
    selectValues: [
      {
        name: "MentalHealthInfo_low_mood_depression_plan_welfare_checks",
        label:
          "Regular welfare checks with the student (this would be subtle and not in front of peers)",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_plan_day_timings",
        label:
          "Provide the student with in-depth information about each element of the programme day-by-day with timings (note these might be approximate and could be subject to change)",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_plan_breaks",
        label:
          "Give the student the opportunity for a short break outside of the room/ environment",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_plan_buddy",
        label:
          "Try to pair the student with another student as a buddy (note this may not always be possible)",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_plan_opt_out_presentations",
        label:
          "Opt out of giving presentations alone (and co-deliver with another student where possible)",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_plan_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        Does the student have any specific support mechanisms that help them if
        they are feeling low or depressed? Please review the suggestions below
        and select all that apply
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the other support",
    name: "MentalHealthInfo_low_mood_depression_plan_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_plan_other",
  },

  {
    Page: "MentalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "MentalHealthInfo_low_mood_depression_support",
    selectValues: [
      {
        name: "MentalHealthInfo_low_mood_depression_support_talking_family_friends",
        label: "Talking with family/ friends",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_support_mental_health_professional",
        label:
          "Support from a mental health professional (e.g. if the student has a therapist they can access during the programme) – please add more information to the ‘other’ box with details",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_support_grounding_techniques",
        label:
          "Grounding techniques such as ‘five things’ (please provide details in the ‘other, please specify’ box below",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_support_breathing_exercises",
        label: "Breathing exercises",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_support_meditation",
        label: "Meditation",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_support_going_for_a_walk",
        label: "Going for a walk",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_support_listening_to_music",
        label: "Listening to music/ podcast",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_support_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If the student is feeling low or depressed, what are some of the ways
        that we can support them in the moment? We will always offer
        compassionate and pastoral support, the following options are some
        practical steps that might assist during programmes, please review the
        suggestions below and select those which could support the student
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the other support",
    name: "MentalHealthInfo_low_mood_depression_support_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_support_other",
  },

  // low_mood_depression Medication start

  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication",
    name: "MentalHealthInfo_low_mood_depression_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression",
    AboveText: (
      <p>Does the student take any medication related to their condition</p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "MentalHealthInfo_low_mood_depression_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_prescribed_medication",
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "MentalHealthInfo_low_mood_depression_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "MentalHealthInfo_low_mood_depression_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "MentalHealthInfo_low_mood_depression_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "MentalHealthInfo_low_mood_depression_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "MentalHealthInfo_low_mood_depression_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "MentalHealthInfo_low_mood_depression_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago)
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "MentalHealthInfo_low_mood_depression_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please click the{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "MentalHealthInfo_low_mood_depression_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_low_mood_depression_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_low_mood_depression_prescribed_medication_interact_badly",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "MentalHealthInfo_low_mood_depression_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_low_mood_depression_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_low_mood_depression_prescribed_medication_anything_else",
  },

  // low_mood_depression Medication end
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Urgent or emergency care",
    name: "MentalHealthInfo_low_mood_depression_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression",
    AboveText: (
      <p>
        Has the student had a serious incident related to their mental health
        and required urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "MentalHealthInfo_low_mood_depression_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "When was the most recent incident",
    name: "MentalHealthInfo_low_mood_depression_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Was the student admitted overnight to the hospital",
    name: "MentalHealthInfo_low_mood_depression_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "NumberFieldForObjectState",
    label: "How many days was the student in hospital",
    name: "MentalHealthInfo_low_mood_depression_serious_incident_attend_hospital_days",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_low_mood_depression_serious_incident_attend_hospital",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "How often",
    name: "MentalHealthInfo_low_mood_depression_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their
        mental health
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "MentalHealthInfo_low_mood_depression_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s mental health
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_low_mood_depression_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_low_mood_depression_anything_else",
  },
  // End low_mood_depression

  // Start self_harming
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Self harm",
    name: "MentalHealthInfo_self_harming",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        We understand this is a sensitive topic, but it is vital that we know
        the student’s needs to ensure they can safely attend our programmes and
        encourage you to be open. Does the student currently engage in
        self-harming behaviours, or have they within the last two years? For
        more information, please click the{" "}
        <a
          href="https://www.nhs.uk/mental-health/feelings-symptoms-behaviours/behaviours/self-harm/"
          target="_blank"
        >
          <strong>NHS link here.</strong>
        </a>
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is the student currently engaging in self-harm behaviours",
    name: "MentalHealthInfo_self_harming_currently",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "Please tell us how the student currently harms themself (e.g. scratches/ cutting)",
    name: "MentalHealthInfo_self_harming_how",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_currently",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "Please tell us how the student used to harm themself (e.g. scratches/ cutting)",
    name: "MentalHealthInfo_self_harming_how",
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: ["Yes"],
    withRegardsTo: "MentalHealthInfo_self_harming_currently",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "When did the student stop engaging in self-harming behaviours",
    name: "MentalHealthInfo_self_harming_currently_when_stop",
    selectValues: [
      "Within the last 3 months",
      "Within the last 6 months",
      "Within the last 12 months",
      "Over one year ago",
      "Over two years ago",
    ],
    onlyAppearIfValueIs: ["No"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_currently",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "MentalHealthInfo_self_harming_signs",
    selectValues: [
      {
        name: "MentalHealthInfo_self_harming_signs_missing_activities",
        label: "Intentionally missing an activity",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_overwhelmed",
        label: "Feeling overwhelmed",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_quiet",
        label: "Quiet, less verbally communicative",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_withdrawn",
        label: "Withdrawal from social situation",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_teary",
        label: "Tearful or easily upset",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_hygine",
        label: "Personal hygiene affected",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_chewing_fingernails",
        label: "Chewing fingernails or nailbeds",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_unable_concentrate",
        label: "Unable to concentrate",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_using_phone",
        label: "Using their phone excessively",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_stomach_pains_headaches",
        label: "Regular stomach pains or headaches",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_apeptite_affected_eating_less",
        label: "Appetite affected (not eating/ eating very little)",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_appetite_affected_eating_more",
        label: "Appetite affected (eating more than usual/ eating a lot)",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_sleeping_less",
        label: "Visibly tired due to poor sleep",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_sleeping_more",
        label: "Sleeping more than usual",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_risk_taking",
        label: "Other risk-taking behaviours",
      },
      {
        name: "MentalHealthInfo_self_harming_signs_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If the student is feeling very low or distressed and thinking about
        self-harm during their programme, InvestIN staff need to know how this
        could manifest for the student so that we can care for their wellbeing
        and safety. Please review the suggestions indicators for the student and
        select the applicable signs
      </p>
    ),
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the risk taking",
    name: "MentalHealthInfo_self_harming_signs_risk_taking_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_signs_risk_taking",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details for any other behaviors",
    name: "MentalHealthInfo_self_harming_signs_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_signs_other",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "How much does this impact their day-to-day",
    name: "MentalHealthInfo_self_harming_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "MentalHealthInfo_self_harming_support",
    selectValues: [
      {
        name: "MentalHealthInfo_self_harming_support_talking_family_friends",
        label: "Talking with family/ friends",
      },
      {
        name: "MentalHealthInfo_self_harming_support_mental_health_professional",
        label:
          "Support from a mental health professional (e.g. if the student has a therapist they can access during the programme) – please add more information to the ‘other’ box with details",
      },
      {
        name: "MentalHealthInfo_self_harming_support_grounding_techniques",
        label:
          "Grounding techniques such as ‘five things’ (please provide details in the ‘other, please specify’ box below",
      },
      {
        name: "MentalHealthInfo_self_harming_support_breathing_exercises",
        label: "Breathing exercises",
      },
      {
        name: "MentalHealthInfo_self_harming_support_meditation",
        label: "Meditation",
      },
      {
        name: "MentalHealthInfo_self_harming_support_going_for_a_walk",
        label: "Going for a walk",
      },
      {
        name: "MentalHealthInfo_self_harming_support_listening_to_music",
        label: "Listening to music/ podcast",
      },
      {
        name: "MentalHealthInfo_self_harming_support_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        Does the student have any specific support mechanisms that help them if
        they are feeling low or distressed and thinking about harming themself?
        Please review the suggestions below and select all that apply
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details on the other support",
    name: "MentalHealthInfo_self_harming_support_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_support_other",
  },

  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Daytime concerns",
    name: "MentalHealthInfo_self_harming_during_programme",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming",
    AboveText: (
      <p>
        Are there concerns the student may self-harm during programme hours?
        (E.g. 10.30 – 17.30)
      </p>
    ),
  },

  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Evening concerns",
    name: "MentalHealthInfo_self_harming_after_programme",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming",
    AboveText: (
      <p>
        Are there concerns the student may self-harm in the evening or overnight
        when they are alone? (E.g. after programmes have finished and students
        have evening activities/ free time to socialise, or when students are
        signed in for bed?)
      </p>
    ),
  },

  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Sharp instruments",
    name: "MentalHealthInfo_self_harming_sharp_instruments",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming",
    AboveText: (
      <p>
        Are there concerns about the student using sharp instruments such as
        scissors or scalpels? (Some programmes will use sharp instruments as
        part of the learning environment, but this will always be supervised).
      </p>
    ),
  },

  // self_harming Medication start

  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication",
    name: "MentalHealthInfo_self_harming_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming",
    AboveText: (
      <p>
        Does the student take any medication related to their mental health and
        self-harm
      </p>
    ),
  },

  //end already mentioned
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "MentalHealthInfo_self_harming_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_prescribed_medication",
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "MentalHealthInfo_self_harming_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "MentalHealthInfo_self_harming_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "MentalHealthInfo_self_harming_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "MentalHealthInfo_self_harming_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "MentalHealthInfo_self_harming_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "MentalHealthInfo_self_harming_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago)
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "MentalHealthInfo_self_harming_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please click the{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "MentalHealthInfo_self_harming_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_self_harming_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_self_harming_prescribed_medication_interact_badly",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "MentalHealthInfo_self_harming_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_self_harming_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_self_harming_prescribed_medication_anything_else",
  },

  // self_harming Medication end
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Urgent or emergency care",
    name: "MentalHealthInfo_self_harming_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming",
    AboveText: (
      <p>
        Has the student had a serious incident related to their mental health
        and required urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "MentalHealthInfo_self_harming_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "When was the most recent incident",
    name: "MentalHealthInfo_self_harming_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Was the student admitted overnight to the hospital",
    name: "MentalHealthInfo_self_harming_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "NumberFieldForObjectState",
    label: "How many days was the student in hospital",
    name: "MentalHealthInfo_self_harming_serious_incident_attend_hospital_days",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_self_harming_serious_incident_attend_hospital",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "How often",
    name: "MentalHealthInfo_self_harming_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to self-harm
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "MentalHealthInfo_self_harming_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s mental health
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_self_harming_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_self_harming_anything_else",
  },
  // End self_harming

  // Start eating_disorder
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Eating disorder",
    name: "MentalHealthInfo_eating_disorder",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        We understand this is a sensitive topic, but it is vital that we know
        the student’s needs to ensure they can safely attend our programmes and
        encourage you to be open.
        <br></br>Does the student currently have, or has previously had, an
        eating disorder. For more information, please click the{" "}
        <a
          href="https://www.nhs.uk/mental-health/feelings-symptoms-behaviours/behaviours/eating-disorders/overview/"
          target="_blank"
        >
          <strong>NHS link here.</strong>
        </a>
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please tell us about their diagnosis ",
    name: "MentalHealthInfo_eating_disorder_diagnosis",
    selectValues: [
      {
        name: "MentalHealthInfo_eating_disorder_diagnosis_anorexia",
        label: "Anorexia Nervosa",
      },
      {
        name: "MentalHealthInfo_eating_disorder_diagnosis_binge_eating",
        label: "Binge eating disorder",
      },
      {
        name: "MentalHealthInfo_eating_disorder_diagnosis_bulimia",
        label: "Bulimia",
      },
      {
        name: "MentalHealthInfo_eating_disorder_diagnosis_restrictive_food_intake",
        label: "Avoidant/ restrictive food intake disorder (ARFID)",
      },
      {
        name: "MentalHealthInfo_eating_disorder_diagnosis_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder",
    SpecialCondition: "Optional",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_eating_disorder_diagnosis_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_diagnosis_other",
  },

  {
    Page: "MentalHealthInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "How much does this impact their day-to-day",
    name: "MentalHealthInfo_eating_disorder_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Hydration concerns",
    name: "MentalHealthInfo_eating_disorder_stay_hydrated",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder",
    AboveText: (
      <p>
        Are there any concerns that the student will not keep themself hydrated
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "MultiSelectFieldForObjectState",
    label: "Please select all that apply",
    name: "MentalHealthInfo_eating_disorder_signs",
    selectValues: [
      {
        name: "MentalHealthInfo_eating_disorder_signs_fainting",
        label: "Prone to fainting",
      },
      {
        name: "MentalHealthInfo_eating_disorder_signs_nausea",
        label: "Nausea",
      },
      {
        name: "MentalHealthInfo_eating_disorder_signs_vomiting",
        label: "Vomiting",
      },
      {
        name: "MentalHealthInfo_eating_disorder_signs_quiet",
        label: "Quiet, less verbally communicative",
      },
      {
        name: "MentalHealthInfo_eating_disorder_signs_withdrawn",
        label: "Become withdrawn",
      },
      {
        name: "MentalHealthInfo_eating_disorder_signs_agitated",
        label: "Agitated or jumpy",
      },
      {
        name: "MentalHealthInfo_eating_disorder_signs_tearful",
        label: "Tearful or easily upset",
      },
      {
        name: "MentalHealthInfo_eating_disorder_signs_unable_concentrate",
        label: "Unable to concentrate",
      },
      {
        name: "MentalHealthInfo_eating_disorder_signs_stomach_pains_headaches",
        label: "Regular stomach pains or headaches",
      },
      {
        name: "MentalHealthInfo_low_mood_depression_signs_sleeping_more",
        label: "Sleeping more than usual",
      },
      {
        name: "MentalHealthInfo_eating_disorder_signs_becoming_tired",
        label: "Becoming tired, sleep affected",
      },
      {
        name: "MentalHealthInfo_eating_disorder_signs_fidgeting",
        label:
          "Fidgeting (e.g. moving hands or fingers a lot, playing with an object such as a pen/ hair etc.)",
      },
      {
        name: "MentalHealthInfo_eating_disorder_signs_using_phone",
        label: "Using their phone excessively",
      },
      {
        name: "MentalHealthInfo_eating_disorder_signs_other",
        label: "Other",
      },
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_anxiety",
    SpecialCondition: "Optional",
    AboveText: (
      <p>
        If the student is struggling with food during their programme, it is
        useful for us to know what this looks like for each student so that we
        can care for their well-being. Please review the indicators below and
        select the applicable signs
      </p>
    ),
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please provide details for any other behaviors",
    name: "MentalHealthInfo_eating_disorder_signs_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_signs_other",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Eat somewhere away from their peers",
    name: "MentalHealthInfo_eating_disorder_eat_away",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder",
    AboveText: (
      <p>
        Will the student need to eat somewhere away from their peers to
        facilitate a healthy food intake? Please note this is not always
        possible during the programme
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Safe foods",
    name: "MentalHealthInfo_eating_disorder_good_safe_food",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder",
    AboveText: (
      <p>
        If the student is struggling with food, please tell us what are some
        foods that they consider to be safe and more easily consumed
      </p>
    ),
  },
  // eating_disorder Medication start

  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication",
    name: "MentalHealthInfo_eating_disorder_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder",
    AboveText: (
      <p>Does the student take any medication related to their condition</p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "MentalHealthInfo_eating_disorder_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_prescribed_medication",
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "MentalHealthInfo_eating_disorder_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "MentalHealthInfo_eating_disorder_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "MentalHealthInfo_eating_disorder_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "MentalHealthInfo_eating_disorder_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "MentalHealthInfo_eating_disorder_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "MentalHealthInfo_eating_disorder_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago)
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "MentalHealthInfo_eating_disorder_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please click the{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "MentalHealthInfo_eating_disorder_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_eating_disorder_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_eating_disorder_prescribed_medication_interact_badly",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "MentalHealthInfo_eating_disorder_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_eating_disorder_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_eating_disorder_prescribed_medication_anything_else",
  },

  // eating_disorder Medication end
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Urgent or emergency care",
    name: "MentalHealthInfo_eating_disorder_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder",
    AboveText: (
      <p>
        Has the student had a serious incident related to their mental health
        and required urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "MentalHealthInfo_eating_disorder_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "When was the most recent incident",
    name: "MentalHealthInfo_eating_disorder_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Was the student admitted overnight to the hospital",
    name: "MentalHealthInfo_eating_disorder_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "NumberFieldForObjectState",
    label: "How many days was the student in hospital",
    name: "MentalHealthInfo_eating_disorder_serious_incident_attend_hospital_days",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_eating_disorder_serious_incident_attend_hospital",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "How often",
    name: "MentalHealthInfo_eating_disorder_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their
        mental health
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "MentalHealthInfo_eating_disorder_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s mental health
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_eating_disorder_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_eating_disorder_anything_else",
  },
  // End eating_disorder

  // Start gender_identity
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Gender identity",
    name: "MentalHealthInfo_gender_identity",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        Does the student experience feelings related to their gender identity?
        For more information about gender identity{" "}
        <a
          href="https://www.youngminds.org.uk/parent/parents-a-z-mental-health-guide/gender-identity/"
          target="_blank"
        >
          <strong>please visit this link. </strong>
        </a>
      </p>
    ),
  },

  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Comfortable talking",
    name: "MentalHealthInfo_gender_identity_comfortbable_talking",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity",
    AboveText: (
      <p>
        If the student is struggling with their mental or physical health
        related to gender dysphoria, is this something they would feel
        comfortable speaking to an InvestIN staff member about? Please be
        assured we would never approach a student to discuss their gender, but
        we will always offer compassion and care if the student discloses they
        would like to talk to someone
      </p>
    ),
  },

  // gender_identity Medication start

  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication",
    name: "MentalHealthInfo_gender_identity_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity",
    AboveText: <p>Does the student take any medication related to this</p>,
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "MentalHealthInfo_gender_identity_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_prescribed_medication",
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "MentalHealthInfo_gender_identity_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "MentalHealthInfo_gender_identity_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "MentalHealthInfo_gender_identity_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "MentalHealthInfo_gender_identity_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "MentalHealthInfo_gender_identity_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "MentalHealthInfo_gender_identity_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago)
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "MentalHealthInfo_gender_identity_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please click the{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "MentalHealthInfo_gender_identity_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_gender_identity_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_gender_identity_prescribed_medication_interact_badly",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "MentalHealthInfo_gender_identity_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_gender_identity_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_gender_identity_prescribed_medication_anything_else",
  },

  // gender_identity Medication end
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Urgent or emergency care",
    name: "MentalHealthInfo_gender_identity_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity",
    AboveText: (
      <p>
        Has the student had a serious incident related to this and required
        urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "MentalHealthInfo_gender_identity_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "When was the most recent incident",
    name: "MentalHealthInfo_gender_identity_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Was the student admitted overnight to the hospital",
    name: "MentalHealthInfo_gender_identity_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "NumberFieldForObjectState",
    label: "How many days was the student in hospital",
    name: "MentalHealthInfo_gender_identity_serious_incident_attend_hospital_days",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_gender_identity_serious_incident_attend_hospital",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "How often",
    name: "MentalHealthInfo_gender_identity_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their
        mental health
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "MentalHealthInfo_gender_identity_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity",
    AboveText: (
      <p>Is there anything else that would be helpful for us to know</p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_gender_identity_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_gender_identity_anything_else",
  },
  // End gender_identity

  // Start other
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label:
      "Does the student experience any other mental health conditions we should be aware of",
    name: "MentalHealthInfo_other",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: false,
    onlyAppearIfValueIsNot: false,
    withRegardsTo: false,
    AboveText: (
      <p>
        Does the student have any other mental health conditions or needs that
        we should be aware of? Please identify each condition (e.g. bipolar
        disorder, post-traumatic stress disorder, phobias, obsessive-compulsive
        disorder).
      </p>
    ),
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please tell us what this is",
    name: "MentalHealthInfo_other_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other",
  },

  {
    Page: "MentalHealthInfo",
    TextField: "SeveritySelectFieldForObjectState",
    label: "How much does this impact their day-to-day",
    name: "MentalHealthInfo_other_severity",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other",
  },

  // other Medication start

  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Medication",
    name: "MentalHealthInfo_other_prescribed_medication",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other",
    AboveText: (
      <p>Does the student take any medication related to their mental health</p>
    ),
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Name of medication",
    name: "MentalHealthInfo_other_prescribed_medication_name",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_prescribed_medication",
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Dosage of medication (e.g. 200mg/ 100mg)",
    name: "MentalHealthInfo_other_prescribed_medication_dosage",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Frequency",
    name: "MentalHealthInfo_other_prescribed_medication_frequency",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_prescribed_medication",
    AboveText: <p>Frequency (e.g. two times per day, or only when needed)</p>,
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label:
      "What time should the student take this medication? (e.g. 9am and 6pm)",
    name: "MentalHealthInfo_other_prescribed_medication_time",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Application (e.g. tablet)",
    name: "MentalHealthInfo_other_prescribed_medication_application",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Instructions (e.g. to be taken with food)",
    name: "MentalHealthInfo_other_prescribed_medication_instructions",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_prescribed_medication",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "Date",
    name: "MentalHealthInfo_other_prescribed_medication_started",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_prescribed_medication",
    AboveText: (
      <p>
        When did the student begin taking this medication? (e.g. DD/MM/YYYY for
        new medications or an approximate date if this is a long-term medication
        that started many years ago)
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Controlled drug",
    name: "MentalHealthInfo_other_prescribed_medication_controlled_drug",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_prescribed_medication",
    AboveText: (
      <p>
        Is this medication a controlled drug? (please click the{" "}
        <a
          href="https://www.gov.uk/government/publications/controlled-drugs-list--2"
          target="_blank"
        >
          <strong>LINK </strong>
        </a>
        here for guidance)
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Bad interactions",
    name: "MentalHealthInfo_other_prescribed_medication_interact_badly",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_prescribed_medication",
    AboveText: (
      <p>
        Does this medicine interact badly, or should not be taken in conjunction
        with, any other medicine
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_other_prescribed_medication_interact_badly_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo:
      "MentalHealthInfo_other_prescribed_medication_interact_badly",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Is there anything else we need to know",
    name: "MentalHealthInfo_other_prescribed_medication_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_prescribed_medication",
    AboveText: (
      <p>
        Is there anything else we need to know about this treatment/ medication
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_other_prescribed_medication_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_prescribed_medication_anything_else",
  },

  // other Medication end

  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Urgent or emergency care",
    name: "MentalHealthInfo_other_serious_incident",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other",
    AboveText: (
      <p>
        Has the student had a serious incident related to their mental health
        and required urgent or emergency treatment within the last 12 months
      </p>
    ),
  },

  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "What was the trigger for the emergency",
    name: "MentalHealthInfo_other_serious_incident_trigger",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "DateFieldForObjectState",
    label: "When was the most recent incident",
    name: "MentalHealthInfo_other_serious_incident_most_recent",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Was the student admitted overnight to the hospital",
    name: "MentalHealthInfo_other_serious_incident_attend_hospital",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_serious_incident",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "NumberFieldForObjectState",
    label: "How many days was the student in hospital",
    name: "MentalHealthInfo_other_serious_incident_attend_hospital_days",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_serious_incident_attend_hospital",
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "How often",
    name: "MentalHealthInfo_other_serious_incident_how_often",
    selectValues: [
      "Once in the last 12 months",
      "Between two and five times within the last 12 months",
      "Between five and ten times within the last 12 months",
      "More than ten times within the last 12 months",
    ],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_serious_incident",
    AboveText: (
      <p>
        How often has the student experienced an incident related to their
        mental health
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "SelectFieldForObjectState",
    label: "Anything else",
    name: "MentalHealthInfo_other_anything_else",
    selectValues: ["Yes", "No"],
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other",
    AboveText: (
      <p>
        Is there anything else that would be helpful for us to know about the
        student’s mental health
      </p>
    ),
  },
  {
    Page: "MentalHealthInfo",
    TextField: "TextFieldForObjectState",
    label: "Please specify",
    name: "MentalHealthInfo_other_anything_else_specify",
    onlyAppearIfValueIs: ["Yes"],
    onlyAppearIfValueIsNot: false,
    withRegardsTo: "MentalHealthInfo_other_anything_else",
  },
  // End other
];
